import React from 'react'

export default function ErrorMsg(props) {
  return (
    <>
    {
        props?.message && <span id="exampleInputEmail1-error" className="form error invalid-feedback">{props?.message}</span>
    }
    </>
  )
}
